export const CRITEO_TIME_DELAY_IN_MS = 1000;
export const CRITEO_INTERSECTION_THRESHOLD = 0.5;
